export const isMac =
  typeof window !== 'undefined'
    ? /macintosh|mac os x/i.test(navigator.userAgent.toLowerCase())
    : false
